export const QUERY_KEYS = {
    CUSTOMERS_LIST: (page, search) => ['customers', 'fino', page, search],
    MERCHANT_CHECK: (agentid) => ['merchantCheck', agentid],
    TRANSACTION_LIMIT: (customerMobile, dmtType) => ['transactionLimit', customerMobile, dmtType],
    BENEFICIARY_LIST: (customerId, page, limit, search) => ['beneficiaryList', customerId, page, limit, search],
    CHECK_MERCHANT_OR_BC: ['checkMerchantOrBc'],
    BANK_LIST: ['bankList']
};
